module.exports = __webpack_public_path__ + "img/base_activites_sentier_interpretation.28969845.svg";